module.exports = __webpack_public_path__ + "img/YGBX.9814263e.png";